export const minGapBetweenButtons = 5;
export const maxGapBetweenButtons = 100;